import React, { useState } from "react";
import { useTranslation } from "react-i18next";
import TabsHeader, { useTabParam } from "../../components/Dashboard/TabsHeader";
import AttributionsTab from "./AttributionsTab";
import AuditTab from "./AuditTab";
import CodesTab from "./CodesTab";
import ProgramsTab from "./ProgramsTab";
import RewardsTab from "./RewardsTab";
import SummaryTab from "./SummaryTab";
import styles from "./Referrals.module.sass";

/**
 * Referidos y socios — sección de ADMIN (06 §2). Pestañas sincronizadas con
 * `?tab=` para poder enlazar a cada una. F3 añade Socios y Liquidaciones.
 */
const TABS = ["summary", "attributions", "rewards", "codes", "programs", "audit"];

const Referrals = () => {
  const { t } = useTranslation();
  const tabs = TABS.map((key) => ({ key, label: t(`referrals.tabs.${key}`) }));
  const [tab, setTab] = useTabParam(tabs, "summary", { sync: true });
  const [attributionStatus, setAttributionStatus] = useState(null);

  return (
    <div className={styles.page}>
      <div className={styles.topBar}>
        <TabsHeader tabs={tabs} active={tab} onChange={setTab} />
      </div>
      {tab === "summary" && (
        <SummaryTab
          onOpenReview={() => {
            setAttributionStatus("REVIEW");
            setTab("attributions");
          }}
        />
      )}
      {tab === "attributions" && <AttributionsTab initialStatus={attributionStatus} />}
      {tab === "rewards" && <RewardsTab />}
      {tab === "codes" && <CodesTab />}
      {tab === "programs" && <ProgramsTab />}
      {tab === "audit" && <AuditTab />}
    </div>
  );
};

export default Referrals;
